// extracted by mini-css-extract-plugin
export default {"card__price":"XGMMQZfDvMXEEYyc2REz"};